const ListeaUsuariosCalificaciones = ({ items, actualiza }) => {

  const abreCadete = (cadete) => {
    actualiza(cadete);
    
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <div style={{ maxWidth: "100%", overflowX: "auto", textAlign: "center" }}>
        <table style={{ width: "90%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th style={{ textAlign: "center", width: "90px" }}>Apellido</th>
              <th style={{ textAlign: "center", width: "250px" }}>Nombre</th>
              <th style={{ textAlign: "center", width: "100px" }}>DNI</th>
            
             
            </tr>
          </thead>
          <tbody>
            {items.map((cadete, index) => {
              return (
                <tr
                  key={index}
                  onClick={() => abreCadete(cadete)}
                  style={{
                    padding: "10px",
                    border: "1px solid #ddd",
                    backgroundColor: "#f9f9f9",
                    textAlign: "left",
                  }}
                >
                  <th style={{ textAlign: "center" }}>
                    {cadete.apellido}
                  </th>
                  <th 
                
                  >
                      {cadete.nombres}
                  </th>
                  <th>{cadete.dni}</th>
                 
               
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ListeaUsuariosCalificaciones;
